// Career timeline for Jason Thompson, curated from his 2026 biography.
// Reverse-chronological (most recent first), Andrea-Bocelli career-page style.

export const TIMELINE_INTRO =
  "Over 45 years at the piano and 30 years teaching — a star-studded career across 25+ countries, straddling jazz, blues, soul, R&B, classical and gospel. These are some of the milestones along the way.";

export const TIMELINE = [
  {
    year: "2026",
    highlight: true,
    items: [
      { title: "Four nights at Ronnie Scott's with Ruby Turner", desc: "Playing four shows for Ruby Turner at the legendary London jazz club." },
      { title: "Boney M across Europe", desc: "Performances from Aarhus, Denmark to the San Fermin Festival in Pamplona, Spain and Oxford University." },
      { title: "Ruby Turner — Symphony Hall, Birmingham", desc: "Playing for the Specsavers annual conference at one of the UK's finest concert halls." },
      { title: "Gospel Rising at Sinfonia Smith Square", desc: "Accompanying a major London choir event." },
    ],
  },
  {
    year: "2025",
    highlight: true,
    items: [
      { title: "Ruby Turner tour + four sold-out nights at Ronnie Scott's", desc: "A tour taking in Gloucester, Ancona (Italy), Brecon (Wales) and the Rye Jazz & Blues Festival." },
      { title: "The Jacksons tour with Boney M — meeting Janet Jackson", desc: "Playing in Pangbourne alongside Sister Sledge on the bill." },
      { title: "London Community Gospel Choir candlelight show", desc: "Playing for the LCGC, one of the UK's most celebrated gospel choirs." },
      { title: "Motown Memoirs at St Martin-in-the-Fields", desc: "Performing in Trafalgar Square." },
    ],
  },
  {
    year: "2024",
    items: [
      { title: "LCGC Baltic & Spain tours", desc: "Playing for the London Community Gospel Choir in Bilbao, and across Latvia, Estonia and Lithuania." },
      { title: "Ruby Turner festival tour", desc: "Bewdley, Ribble Valley Jazz & Blues, Stroud and Sidmouth." },
      { title: "Motown house band residency", desc: "A run at the Cumberland Hotel, Marble Arch." },
    ],
  },
  {
    year: "2023",
    items: [
      { title: "Get Up Stand Up — the Bob Marley musical", desc: "Playing piano on the West End theatre show." },
      { title: "Touring Cuba with Boney M", desc: "Bringing the music to Havana." },
      { title: "Recording for Kym Mazelle", desc: "Tracking with the First Lady of House Music." },
    ],
  },
  {
    year: "2021",
    items: [
      { title: "Recording piano for Mica Paris at Warner Music", desc: "Studio sessions for radio and promo videos." },
      { title: "Mica Paris festival season", desc: "Ronnie Scott's, the Rye and Stroud Jazz Festivals, the Rhondda Arts Festival and more." },
    ],
  },
  {
    year: "2014 – 2021",
    highlight: true,
    items: [
      { title: "Musical Director for Mica Paris", desc: "Seven years directing the band for one of Britain's great soul voices — from Ronnie Scott's to the Dubai Opera House, plus a Songs of Praise recording." },
    ],
  },
  {
    year: "2020",
    items: [
      { title: "Songs of Praise with Mica Paris", desc: "A recorded performance aired on the BBC." },
      { title: "Mica Paris at the Dubai Opera House", desc: "Performing at one of the world's landmark venues." },
    ],
  },
  {
    year: "2017",
    items: [
      { title: "Piano & singing lessons for Jennifer Hudson's son", desc: "Engaged by an international head-hunter while she judged The Voice UK." },
      { title: "Love Supreme Festival with Mica Paris", desc: "Featured on Ashley Banjo's TV series Big Town Dance at the festival." },
      { title: "Vocal coach — Five Guys Named Moe", desc: "Coaching the cast of the theatre show." },
    ],
  },
  {
    year: "2010 – 2013",
    items: [
      { title: "Novara Gospel Festival, Italy", desc: "Returning yearly, playing for Kurt Carr, Myron Butler, Jonathan Nelson, Micah Stampley and 21:03." },
      { title: "TV appearances", desc: "Featuring in the series Misfits and Hotel Babylon." },
    ],
  },
  {
    year: "2006 – 2009",
    highlight: true,
    items: [
      { title: "Musical Director for Ruby Turner", desc: "Playing and singing as MD across her UK and European tours." },
      { title: "David Gest 'My Life' Tour", desc: "Joining the touring band." },
      { title: "Ashford & Simpson — ASCAP Awards & European tour", desc: "Performing with the legendary songwriting duo." },
      { title: "Oleta Adams & Womack & Womack UK tours", desc: "Backing soul royalty on the road." },
    ],
  },
  {
    year: "2005",
    items: [
      { title: "Roland UK artist endorsement", desc: "Endorsed since 2005 — a platform used to fund studios and equipment for schools." },
      { title: "The Isley Brothers at the Royal Albert Hall", desc: "Playing for the support act at the iconic venue." },
      { title: "Cheltenham Jazz Festival", desc: "On a bill featuring Herbie Hancock." },
      { title: "The film 'Amazing Grace'", desc: "Singing in the select choir on the soundtrack." },
    ],
  },
  {
    year: "2003 – 2005",
    highlight: true,
    items: [
      { title: "Musical Director — 'Lady Day at Emerson's Bar and Grill'", desc: "MD for the national tour of the theatre show." },
      { title: "Musical Director — 'Simply Heavenly', West End", desc: "At Trafalgar Studios; the show was nominated for an Olivier Award for Best New Musical. Performed on ITV for the Evening Standard Awards." },
      { title: "Walt Disney's Prom in the Park", desc: "Performing for the BBC at Hyde Park." },
    ],
  },
  {
    year: "2000 – 2001",
    highlight: true,
    items: [
      { title: "Performing for the Pope — World Youth Day, Italy", desc: "Accompanying gospel sensation CeCe Winans with a 100-piece choir and 500-piece orchestra, before an audience of one million." },
      { title: "Richard Smallwood Orchestra, Denmark", desc: "Performing with 1,000 singers." },
      { title: "Touring Japan", desc: "Bringing the music to the Far East." },
    ],
  },
  {
    year: "Training",
    items: [
      { title: "Classically trained, Grade 8 piano", desc: "Rooted in the church where he grew up." },
      { title: "Advanced Jazz Piano, Goldsmiths University, London", desc: "Formal study of the jazz language." },
      { title: "BA (Hons) & BEd in Music Education", desc: "The foundation for 30+ years of teaching — with a 100% exam pass rate for private students." },
    ],
  },
];

// A few marquee names, for the 'shared the stage with' strip.
export const TIMELINE_ARTISTS = [
  "Ruby Turner", "Mica Paris", "Boney M", "CeCe Winans", "The Isley Brothers",
  "Ashford & Simpson", "Oleta Adams", "Maxi Priest", "Leona Lewis", "Corinne Bailey-Rae",
  "Beverley Skeete", "Kym Mazelle", "Sam Smith", "Incognito", "Shaun Escoffery",
];
